const addTestId = (id?: string) =>
  process.env.NODE_ENV === 'production' ? {} : { 'data-testid': id };

export default addTestId;
